<div class="tm-list-progress-photo-editor">
    <div #canvasImage class="tm-list-progress-photo-editor__drawingArea">
        <canvas
            #editPhotoCanvas
            class="tm-list-progress-photo-editor__drawingArea-canvas"
        >
        </canvas>
        <div
            #canvasCropArea
            [ngClass]="{
                'tm-list-progress-photo-editor--hidden': !hasCropBox()
            }"
        >
            <div
                #cropMask
                (ended)="onDragEnd($event)"
                (started)="onDragStart($event)"
                (touchmove)="onTouchDrag($event)"
                [ngClass]="{
                    'tm-list-progress-photo-editor--invalid': !!isCropMaskInvalid
                }"
                [style.height.px]="mask.height"
                [style.left.px]="mask.topLeft.x"
                [style.top.px]="mask.topLeft.y"
                [style.width.px]="mask.width"
                class="tm-list-progress-photo-editor__crop-mask"
                id="crop-mask"
                tmDraggable
            ></div>
            <div
                #cornerTopLeft
                (ended)="onDragEnd($event)"
                (started)="onDragStart($event)"
                (touchmove)="onTouchDrag($event)"
                [style.left.px]="mask.topLeft.x + cropCornerOffsetX"
                [style.top.px]="mask.topLeft.y + cropCornerOffsetY"
                class="tm-list-progress-photo-editor__crop-corner tm-list-progress-photo-editor__crop-corner-top-left"
                id="crop-corner-top-left"
                tmDraggable
            >
                <div
                    class="tm-list-progress-photo-editor__crop-circle tm-list-progress-photo-editor__cropcircle-top-left"
                ></div>
            </div>
            <div
                #cornerTopRight
                (ended)="onDragEnd($event)"
                (started)="onDragStart($event)"
                (touchmove)="onTouchDrag($event)"
                [style.left.px]="mask.topRight.x + cropCornerOffsetX"
                [style.top.px]="mask.topRight.y + cropCornerOffsetY"
                class="tm-list-progress-photo-editor__crop-corner tm-list-progress-photo-editor__crop-corner-top-right"
                id="crop-corner-top-right"
                tmDraggable
            >
                <div
                    class="tm-list-progress-photo-editor__crop-circle tm-list-progress-photo-editor__cropcircle-top-right"
                ></div>
            </div>
            <div
                #cornerBottomLeft
                (ended)="onDragEnd($event)"
                (started)="onDragStart($event)"
                (touchmove)="onTouchDrag($event)"
                [style.left.px]="mask.bottomLeft.x + cropCornerOffsetX"
                [style.top.px]="mask.bottomLeft.y + cropCornerOffsetY"
                class="tm-list-progress-photo-editor__crop-corner tm-list-progress-photo-editor__crop-corner-bottom-left"
                id="crop-corner-bottom-left"
                tmDraggable
            >
                <div
                    class="tm-list-progress-photo-editor__crop-circle tm-list-progress-photo-editor__cropcircle-bottom-left"
                ></div>
            </div>
            <div
                #cornerBottomRight
                (ended)="onDragEnd($event)"
                (started)="onDragStart($event)"
                (touchmove)="onTouchDrag($event)"
                [style.left.px]="mask.bottomRight.x + cropCornerOffsetX"
                [style.top.px]="mask.bottomRight.y + cropCornerOffsetY"
                class="tm-list-progress-photo-editor__crop-corner tm-list-progress-photo-editor__crop-corner-bottom-right"
                id="crop-corner-bottom-right"
                name="cropCornerBottomRight"
                tmDraggable
            >
                <div
                    class="tm-list-progress-photo-editor__crop-circle tm-list-progress-photo-editor__cropcircle-bottom-right"
                ></div>
            </div>
        </div>
    </div>
</div>
